<div class="my-2 pe-1" *transloco="let t">
   <h2 class="text-xl font-bold text-black">{{ t('researchhistory.title') }}</h2>
   <div class="flex gap-3 flex-col">
      @if(shouldShowSessions) {
         @if(!saveSessionsEnabled) {
            <div class="t-research-history-empty text-black mt-2">{{ t('researchhistory.disabled') }}</div>
         }
         @else if(anonymousUser) {
            <div class="t-research-history-available text-black mt-2">{{ t('researchhistory.anonymous') }}</div>
         }
         @if(shouldShowAlmostMaxSizeWarning) {
            <div class="t-research-history-maxsize-almostreached mt-2 text-black inline-flex items-center gap-1 text-sm border border-red-700 p-2 rounded">
               {{ t('researchhistory.maxsize.almostreached', {left: maxHistorySize - qandaCount}) }}
            </div>
         }
         @else if(shouldShowMaxSizeWarning) {
            <div class="t-research-history-maxsize-reached mt-2 text-black inline-flex items-center gap-1 text-sm border border-red-700 p-2 rounded">
               {{ t('research.status.maxhistorysize') }}
            </div>
         }
         @if(researchHistory.today.length > 0) {
            <h3 class="me-1 text-gray-500 pt-2 text-sm">{{t('researchhistory.today')}}</h3>
            @for(session of researchHistory.today; track session.id) {
               <app-research-session [session]="session"></app-research-session>
            }
         }
         @if(researchHistory.lastxdays.length > 0) {
            <h3 class="me-1 text-gray-500 pt-2 text-sm">{{t('researchhistory.lastxdays', { days })}}</h3>
            @for(session of researchHistory.lastxdays; track session.id) {
               <app-research-session [session]="session"></app-research-session>
            }
         }
         @if(hasOlderSessions) {
            @for(sessionsPerYear of researchHistory.older; track sessionsPerYear.year) {
               <h3 class="me-1 text-gray-500 pt-2 text-sm">{{sessionsPerYear.year}}</h3>
               @for(session of sessionsPerYear.sessions; track session.id) {
                  <app-research-session [session]="session"></app-research-session>
               }
            }
         }
      } @else {
         <div class="t-research-history-empty text-black mt-2">{{ t('researchhistory.empty') }}</div>
      }

   </div>
</div>